import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';
import { IGP_WEBSITE_URL } from '../../../core/config';
import { usePathBuilder } from '../../../core/routing/hooks/use-path-builder';
import { Icon } from '../../icon/icon';
import { Typography } from '../../typography/typography';
import styles from './app-header-switch-items.module.scss';

export const AppHeaderSwitchItems: React.FC = () => {
  const { t } = useTranslation();
  const { homePath } = usePathBuilder();

  return (
    <div className={styles.root}>
      <RouterLink className={styles.shopSwitch} to={homePath()}>
        <Typography className={styles.linkText} tag="span" variant="buttontext">
          {t('global.shop')}
        </Typography>
      </RouterLink>
      <div className={styles.divider} />
      <RouterLink className={styles.websiteLink} rel="noopener noreferrer" target="_blank" to={IGP_WEBSITE_URL}>
        <Typography className={styles.linkText} tag="span" variant="buttontext">
          {t('global.website')}
        </Typography>
        <Icon className={styles.linkIcon} size="24" variant="arrow-up-right" />
      </RouterLink>
    </div>
  );
};
